import { ColorPalette2022Branding, ColorPaletteGrey, WHITE } from '../theme.palette';
import { addStyles, DefaultTheme, rgba } from '../theme';

export const CSS = {
	container: 'c-Stepper',
	step: 'c-Stepper__Step',
	connector: 'c-Stepper__Connector',
	badge: 'c-Stepper__Badge',
	badgeComplete: 'c-Stepper__Badge--Complete',
	badgeCurrent: 'c-Stepper__Badge--Current',
	badgeUpcoming: 'c-Stepper__Badge--Upcoming',
	label: 'c-Stepper__Label',
	labelUpcoming: 'c-Stepper__Label--Upcoming',
};

addStyles({
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		width: '100%',
	},
	[CSS.step]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		'flex-shrink': 0,
	},
	[CSS.connector]: {
		flex: 1,
		height: '1px',
		background: rgba(ColorPaletteGrey.C400),
		margin: `0 ${DefaultTheme.space(3)}`,
	},
	[CSS.badge]: {
		width: '22px',
		height: '22px',
		'border-radius': '50%',
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'font-size': '0.75rem',
		'font-weight': 700,
		color: rgba(WHITE),
		'flex-shrink': 0,
	},
	[CSS.badgeComplete]: {
		background: ColorPalette2022Branding.success,
	},
	[CSS.badgeCurrent]: {
		background: DefaultTheme.color.accent,
	},
	[CSS.badgeUpcoming]: {
		background: rgba(ColorPaletteGrey.C400),
	},
	[CSS.label]: {
		'font-weight': 700,
		'white-space': 'nowrap',
	},
	[CSS.labelUpcoming]: {
		color: DefaultTheme.font.color.supporting,
		'font-weight': 400,
	},
});
